import React from 'react';
import styled from 'astroturf/react';
import * as CSS from 'csstype';

type Props = {
  className?: string;
  marginRight?: number;
  size?: number;
  style?: CSS.Properties;
};

const Container = styled.div`
  align-items: center;
  display: inline-flex;
  vertical-align: middle;
`;

const Dot = styled('div').attrs<{ size: number }>(({ size, ...props }) => ({
  style: {
    height: `${size}px`,
    width: `${size}px`,
  },
  ...props,
}))`
  @keyframes loading-dot {
    0% {
      transform: scale(0.5);
    }
    100% {
      transform: scale(1);
    }
  }

  animation: loading-dot 500ms both infinite cubic-bezier(0.7, 0, 0.3, 1)
    alternate;
  background: #4b4b4b;
  border-radius: 50%;

  &:not(:last-of-type) {
    margin-right: 4px;
  }

  &:nth-child(1) {
    animation-delay: -250ms;
  }

  &:nth-child(2) {
    animation-delay: -125ms;
  }
`;

const LoadingDots = ({ className, marginRight, size = 12, style }: Props) => (
  <Container style={{ marginRight: marginRight ?? size, ...style }}>
    <Dot className={className} size={size} />
    <Dot className={className} size={size} />
    <Dot className={className} size={size} />
  </Container>
);

export default LoadingDots;
